
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import TalkToSales from './TalkToSales';

const ContentMarketingSupportSection: React.FC = () => {
  const addOns = [
    {
      title: "Consumer Evidence Report",
      price: "$2,000",
      subtitle: "must meet statistical significance eligibility",
      description: "Scientists reviewed report for retailers & investors"
    },
    {
      title: "Influencer Video",
      subtitle: "backed by data",
      price: "$350/ panelist",
      description: "Short video + real CGM data for your marketing"
    },
    {
      title: "Testimonial Video",
      subtitle: "backed by data", 
      price: "$150/ panelist",
      description: "Short video + real CGM data for your marketing"
    },
    {
      title: "Additional Glycemic + Satiety Results",
      price: "$150/ panelist",
      description: "Purchase additional results if available"
    },
    {
      title: "Tastermonial Store Listing & Testimonial Page",
      price: "Included",
      description: "Reach out to us to learn more"
    }
  ];

  return (
    <div className="mt-16 mb-6 pt-10">
      <div className="text-center max-w-3xl mx-auto mb-10 animate-on-scroll">
        <h3 className="text-2xl font-bold mb-4">
          Add-on Contents & Marketing Support
        </h3>
        <TalkToSales 
          buttonText="Contact us"
          className="bg-primary hover:bg-primary/90 text-white"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 max-w-7xl mx-auto">
        {addOns.map((addon, index) => (
          <Card key={index} className="bg-white border-gray-300 border p-6 animate-on-scroll">
            <CardContent className="p-0">
              <h4 className="text-lg font-bold mb-2 leading-tight text-gray-800">
                {addon.title}
                {addon.subtitle && (
                  <span className="block text-sm font-normal text-gray-600">
                    {addon.subtitle}
                  </span>
                )}
              </h4>
              
              <div className="mb-4">
                <p className="text-xl font-bold text-gray-800">
                  {addon.price}
                </p>
                {addon.subtitle === "must meet statistical significance eligibility" && (
                  <p className="text-xs italic text-gray-500 mt-1">
                    {addon.subtitle}
                  </p>
                )}
              </div>

              <p className="text-sm leading-relaxed text-gray-600">
                {addon.description}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ContentMarketingSupportSection;
